export default __webpack_public_path__ + "static/media/tigerbox_touch_dark_blue.7ca0d65c.png";